<div class="row gridMargin">

  <!-- mobile view filter popup template start -->
  <div class="mobileViewFilterComponent">
    <div [hidden]="!_isMVFilterPopupOpen" class="mvFilterPopupWrapper"></div>
    @if (_isMVFilterPopupOpen) {
      <kendo-window>
        <div class="window-content">
          <kendo-filter #filter [filters]="mvFilters" [value]="mvFilterValue"></kendo-filter>
          <div class="buttonBlock">
            <button kendoButton (click)="applyFilter(filter.value)" class="primary">Apply filter</button>
            <button kendoButton (click)="clearFilter()">Clear filter</button>
            <button kendoButton (click)="closeFilterPopup()">Cancel</button>
          </div>
        </div>
      </kendo-window>
    }
  </div>
  <!-- mobile view filter popup template end -->

  <!-- main common grid started -->
  <kendo-grid [rowClass]="rowCallback" #grid="kendoGrid" [kendoGridBinding]="gridData" [pageSize]="pageSize"
    [pageable]="pageable" [sortable]="allowSorting" [filterable]="showColumnFilter" [selectable]="true"
    [navigable]="true" [(expandedDetailKeys)]="expandedDetailKeys" [kendoGridExpandDetailsBy]="expandDetailsBy"
    (pageChange)="pageChange($event)" (filterChange)="filterChange($event)" (sortChange)="sortChange($event)"
    [sort]="sort" [filter]="filter" [skip]="skip">

    <!-- other links and buttons related to table -->
    <ng-template kendoGridToolbarTemplate>
      <div class="toolbar-block"
        [ngClass]="{'disclaimer' : !(tabelID == 'productDetails' || tabelID == 'modelDetails' || tabelID == 'categoryDetails')}">

        @if (!(tabelID == 'productDetails' || tabelID == 'modelDetails' || tabelID == 'categoryDetails')) {
          <div class="disclaimer-content">
            <span>
              {{constants.LISTING_DETAILS_MSG}}
            </span>
          </div>
        }
        <div class="info-link">
          <span (click)="openInfoLink()">{{viewInfoLinkName}}</span>
        </div>
        <div class="pdf-div mouse-cursor resultCountMargin" role="img">

          @if (tabelID == 'productDetails' || tabelID == 'modelDetails' ||  tabelID == 'categoryDetails') {
            <div class="head-right displayFlex">
              <app-shared-link [type]="tabelID"></app-shared-link>
            </div>
          }

          <span (click)="exportToPDF(grid, tabelID)">
            <img class="img-pdf" id="PDFBtn" title="PDF Download" filter="img" src="assets/images/PDF.png"
              alt="pdf-icon">
            <span class="pdfDownloadText">
              Download as PDF
            </span>
          </span>

          @if (tabelID == 'productDetails' || tabelID == 'modelDetails' ||  tabelID == 'categoryDetails') {
            <span class="margin-left50" (click)="toggleAllFootnotes()">
              @if (!isExpandAllClicked) {
                <span class="pdfDownloadText">
                  Expand all Footnotes
                </span>
              }
              @if (isExpandAllClicked) {
                <span class="pdfDownloadText">
                  Collapse all Footnotes
                </span>
              }
              <img [ngClass]="isExpandAllClicked ? 'rotateimg' : ''"
                [src]="isExpandAllClicked ? 'assets/images/normal_path_3618_u13104.svg' : 'assets/images/normal_path_3618_u13104.svg'"
                alt="expand-icon" [title]="isExpandAllClicked ? 'Collapse all Footnotes' : 'Expand all Footnotes'"
                filter="img" class="marginLeft10">
            </span>
          }
        </div>
      </div>

      <!-- open filter popup button -->
      <div class="filterBtn-block">
        @if (selectedFilter.length === 0) {
          <button kendoButton (click)="openFilterPopup()">Filter</button>
        } @else {
          <button kendoButton (click)="openFilterPopup()">Edit Filter</button>
        }
      </div>

      <!-- selected filter list -->
      @if (selectedFilter.length > 0) {
        <div class="selectedFilterContainer">
          @for (filter of selectedFilter; track filter) {
            <div class="selectedFilter">
              <span class="filterLbl">{{filter.title}}: <span class="filterTxt">{{filter.value}}</span></span>
              <img src="assets/images/filterClose.svg" alt="remove filter" (click)="removeSingleFilter(filter)">
              <!-- <span class="filterLbl">{{filter.title}}</span>
              <span>:</span>
              <span class="filterTxt">{{filter.value}}</span>
              <img src="assets/images/filterClose.svg" alt="remove filter" (click)="removeSingleFilter(filter)"> -->
            </div>
          }
        </div>
      }
    </ng-template>

    <!-- mobile view table grid content template start -->    
    <kendo-grid-column [sortable]="true">
      <ng-template kendoGridCellTemplate let-dataItem>
        @for (column of GridColumns; track column) {
          <dl>
            <dt><label>{{ column.TITLE }}</label></dt>
            <dd>

              <!-- template grid cell rendering start -->
              @if ((dataItem[column.FIELD] != '' && dataItem[column.FIELD] != null) && column?.FIELD != 'MODEL' && column?.FIELD !='MODEL_NUMBER' && column?.FIELD !='SUCTION_OUTLET_FITTING_MODEL' && column?.FIELD != 'TRADE_NAME' && column?.FIELD != 'WATER_CONTACT_MATERIAL' && column?.FIELD != 'WATER_CONTACT_TEMP' && column?.FIELD != 'END_USES' && column?.FIELD != 'FOR_USE_WITH' && column?.FIELD != 'MAX_PRESSURE' && column?.FIELD != 'MAX_TEMP' && column?.FIELD != 'FACILITY_LOCATION' && column?.FIELD != 'PRODUCT_SERIES_NUMBER' && column?.FIELD != 'CERTIFICATE_NUMBER' && column?.FIELD != 'CERTIFICATION_NUMBER' && column?.FIELD != 'SELF_CERTIFICATION' && column?.FIELD!='PERFORMANCE_STANDARD' && column?.FIELD != 'PERFORMANCE_STANDARD_DISPLAY' && column?.FIELD != 'VIEW_MODEL_LISTING_DETAILS' && column?.FIELD != 'VIEW_PRODUCT_LISTING_DETAILS' && column?.FIELD != 'VIEW_LISTING_DETAILS' && column?.FIELD != 'RELATED_FOOTNOTES'  && column?.FIELD != 'TRADE_DESIGNATION' && column?.FIELD !='SUCTION_FITTING_MODEL') {
                <p class="txtBreak">
                  @if (isSearchHighlight) {
                    <span  class="txtBreak" [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                  } @else {
                    <span class="txtBreak">  {{dataItem[column.FIELD]}}</span> 
                  }
                </p>
              } @else {
                @if ((dataItem[column.FIELD] == null || dataItem[column.FIELD] == '') && (column?.FIELD != 'VIEW_MODEL_LISTING_DETAILS' && column?.FIELD != 'VIEW_PRODUCT_LISTING_DETAILS' && column?.FIELD != 'VIEW_LISTING_DETAILS' && column?.FIELD != 'RELATED_FOOTNOTES')) {
                  <p>
                    -
                  </p>
                }
              }

              @if (column?.FIELD == 'TRADE_DESIGNATION') {
                <p>
                  @if (dataItem.LOGO_URL != null) {
                    <img class="imgDimensions" [src]="dataItem.LOGO_URL" onerror="this.style.display='none'"/>
                  }
                  @if (dataItem.LOGO_URL == null) {
                    <span class="wrap_line">
                      @if (isSearchHighlight) {
                        <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                      } @else {
                        {{dataItem[column.FIELD]}}
                      }
                    </span>
                  }
                </p>
              }

              @if (column?.FIELD == 'VIEW_PRODUCT_LISTING_DETAILS' || column?.FIELD == 'VIEW_MODEL_LISTING_DETAILS' || column?.FIELD == 'VIEW_LISTING_DETAILS') {
                <p class="download">
                  <img [src]="'assets/images/Asset3mdpi.png'" [alt]="column.FIELD" class="listingDetails"
                  (click)="sendClickedData(dataItem.SEQ, dataItem[column?.FIELD], column?.FIELD,'',dataItem)"
                    style="cursor:pointer;" id="{{column.FIELD}}Icon">
                </p>
              }

              @if (dataItem[column.FIELD] != null && column?.FIELD === 'MODEL' && column?.IsClickField !=true) {
                <div>
                  @if (isViewModel(dataItem[column.FIELD])) {
                    <p>
                      <a (click)="addViewModelData(dataItem.PRO_SEQ, dataItem.isclicked = !dataItem.isclicked, dataItem.MODEL);"
                        class="table-ancher">
                        <span [ngClass]="dataItem.isclicked ? 'modelLabelClicked' : ''">View Models</span>
                        <img [ngClass]="dataItem.isclicked ?  'imgclicked' : ''"
                          [src]="dataItem.isclicked? 'assets/images/normal_path_3618_u13104.svg' : 'assets/images/normal_path_3618_u13104.svg'"
                          alt="expand-icon" title="View Models" filter="img">
                      </a>
                      <span [ngClass]="dataItem.isclicked ? 'modelLabelCount' : 'modelLabelCount_normal'" class="block"
                        [ngBind]="calcViewModelCount(dataItem, dataItem[column.FIELD])">
                        {{dataItem.viewModelCount}} <span
                          [ngClass]="dataItem.isclicked ? 'modelLabeltext' : 'modelLabeltext_normal'"> Models exists</span>
                      </span>
                    </p>
                  }

                  @if (!isViewModel(dataItem[column.FIELD])) {
                    <p>
                      @if (dataItem['MODEL_LINK']) {
                        <a class="grid-atag" (click)="certDownloadData(dataItem['MODEL_LINK'])">
                          <span class="txtBreak" [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                        </a>
                      } @else {
                        @if (isSearchHighlight) {
                          <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                        } @else {
                          {{dataItem[column.FIELD]}}
                        }
                      }
                    </p>
                  }			  
                </div>
              }

              @if (dataItem[column.FIELD] != null && (column?.FIELD === 'MODEL' || column?.FIELD === 'MODEL_NUMBER' || column?.FIELD === 'SUCTION_OUTLET_FITTING_MODEL' || column?.FIELD === 'FOR_USE_WITH' || column?.FIELD === 'TRADE_NAME' || column?.FIELD === 'TRADE_DESIGNATION' || column?.FIELD === 'SUCTION_FITTING_MODEL') && column?.IsClickField == true) {
                <div>
                  <a class="grid-atag" (click)="sendClickedData(dataItem.MODEL_SEQ, dataItem['VIEW_MODEL_LISTING_DETAILS'], column?.FIELD, dataItem[column?.FIELD],dataItem)">
                    <span class="txtBreak" [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                  </a>
                </div>
              }
              @if (dataItem[column.FIELD] != null && column?.FIELD === 'MODEL_NUMBER' && column?.IsClickField !=true) {
                <div>
                  <span  [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                </div>
              }
              @if (dataItem[column.FIELD] != null && column?.FIELD === 'SUCTION_OUTLET_FITTING_MODEL' && column?.IsClickField !=true) {
                <div>
                  <span class="txtBreak"  [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                </div>
              }
              @if (dataItem[column.FIELD] != null && column?.FIELD === 'SUCTION_FITTING_MODEL' && column?.IsClickField !=true) {
                <div>
                  <span  [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                </div>
              }
              @if (dataItem[column.FIELD] != null && column?.DATA_TYPE === 'HYPERLINK' && (column?.FIELD === 'END_USES' ||  column?.FIELD === 'WATER_CONTACT_TEMP' ||  column?.FIELD === 'WATER_CONTACT_MATERIAL') && column?.IsClickField == true) {
                <div>
                  <a class="grid-atag" (click)="sendClickedData(dataItem.MODEL_SEQ, dataItem['VIEW_MODEL_LISTING_DETAILS'], column?.FIELD, dataItem[column?.FIELD],dataItem)">
                    <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                  </a>
                </div>
              }
    
              @if (dataItem[column.FIELD] != null && column?.DATA_TYPE != 'HYPERLINK' && (column?.FIELD === 'END_USES' ||  column?.FIELD === 'WATER_CONTACT_TEMP' ||  column?.FIELD === 'WATER_CONTACT_MATERIAL') && column?.IsClickField == true) {
                <div>
                  <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                </div>
              }

              @if (dataItem[column.FIELD] != null && column?.FIELD === 'TRADE_NAME' && column?.IsClickField != true) {
                <div>
                  <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                </div>
              }
              
              @if (dataItem[column.FIELD] != null && (column.FIELD == 'PERFORMANCE_STANDARD_DISPLAY' || column.FIELD == 'PERFORMANCE_STANDARD')  && column?.IsClickField == true) {
                <div>
                  <!-- @if (dataItem['PERFORMANCE_STANDARD_LINK']) {
                    <a class="grid-atag" (click)="sendDownloadData(dataItem.PERFORMANCE_STANDARD_LINK)">
                      <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                    </a>
                  } -->
                  @if (dataItem['PERFORMANCE_STANDARD_LINK']) {
                    <a class="grid-atag">
                      @if (dataItem[column.FIELD] != null) {
                        <span>
                          @for (prop of dataItem['PERFORMANCE_STANDARD_LINK']; track prop; let i = $index) {
                            @if (prop.link == null) {
                              <span class="over-grid-tag" [innerHTML]="prop.name | highlight: searchText" ></span>
                            }
                            @if (i!=dataItem['PERFORMANCE_STANDARD_LINK'].length-1) {
                              <span>&#44;&nbsp;</span>
                            }
                            @if (prop.link != null) {
                              <span [innerHTML]="prop.name | highlight: searchText" (click)="sendDownloadData(prop.link)"></span>
                            }
                          }
                        </span>
                      }
                    </a>
                  }
                  @if (!dataItem['PERFORMANCE_STANDARD_LINK']) {
                    <span [innerHTML]="dataItem[column.FIELD]"></span>
                  }
                </div>
              }
              @if (dataItem[column.FIELD] != null && column.FIELD == 'FACILITY_LOCATION'  && column?.IsClickField == true) {
                <div>
                  @if (dataItem['FACILITY_LOCATION_CERTLINK']) {
                    <a class="grid-atag" (click)="facilityDownloadData(dataItem.FACILITY_LOCATION_CERTLINK)">
                      <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                    </a>
                  }
                  @if (!dataItem['FACILITY_LOCATION_CERTLINK']) {
                    <span [innerHTML]="dataItem[column.FIELD]"></span>
                  }
                </div>
              }
              @if (dataItem[column.FIELD] != null && column.FIELD == 'PRODUCT_SERIES_NUMBER'  && column?.IsClickField == true) {
                <div>
                  @if (dataItem['PRODUCT_SERIES_NUMBER_LINK']) {
                    <a class="grid-atag" (click)="facilityDownloadData(dataItem.PRODUCT_SERIES_NUMBER_LINK)">
                      <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                    </a>
                  }
                  @if (!dataItem['PRODUCT_SERIES_NUMBER_LINK']) {
                    <span [innerHTML]="dataItem[column.FIELD]"></span>
                  }
                </div>
              }
              @if (dataItem[column.FIELD] != null && column.FIELD == 'CERTIFICATE_NUMBER'  && column?.IsClickField == true) {
                <div>
                  @if (dataItem['CERTIFICATE_NUMBER_LINK']) {
                    <a class="grid-atag" (click)="certDownloadData(dataItem.CERTIFICATE_NUMBER_LINK)">
                      <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                    </a>
                  }
                  @if (!dataItem['CERTIFICATE_NUMBER_LINK']) {
                    <span [innerHTML]="dataItem[column.FIELD]"></span>
                  }
                </div>
              }
              @if (dataItem[column.FIELD] != null && column.FIELD == 'CERTIFICATION_NUMBER'  && column?.IsClickField == true) {
                <div>
                  @if (dataItem['CERTIFICATION_NUMBER_LINK']) {
                    <a class="grid-atag" (click)="registrationDownloadData(dataItem.CERTIFICATION_NUMBER_LINK)">
                      <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                    </a>
                  }
                  @if (!dataItem['CERTIFICATION_NUMBER_LINK']) {
                    <span [innerHTML]="dataItem[column.FIELD]"></span>
                  }
                </div>
              }
              @if (dataItem[column.FIELD] != null && column.FIELD == 'SELF_CERTIFICATION'  && column?.IsClickField == true) {
                <div>
                  @if (dataItem['SELF_CERTIFICATION_LINK']) {
                    <a class="grid-atag" (click)="certDownloadData(dataItem.SELF_CERTIFICATION_LINK)">
                      <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                    </a>
                  }
                  @if (!dataItem['SELF_CERTIFICATION_LINK']) {
                    <span [innerHTML]="dataItem[column.FIELD]"></span>
                  }
                </div>
              }
              @if (dataItem[column.FIELD] != null && column.FIELD == 'REGISTRATION_NUMBER'  && column?.IsClickField == true) {
                <div>
                  @if (dataItem['REGISTRATION_NUMBER_LINK']) {
                    <a class="grid-atag" (click)="registrationDownloadData(dataItem.REGISTRATION_NUMBER_LINK)">
                      <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                    </a>
                  }
                  @if (!dataItem['REGISTRATION_NUMBER_LINK']) {
                    <span [innerHTML]="dataItem[column.FIELD]"></span>
                  }
                </div>
              }
              @if (dataItem[column.FIELD] != null && column.FIELD == 'PRODUCT_DESIGNATION'  && column?.IsClickField == true) {
                <div>
                  @if (dataItem['PRODUCT_DESIGNATION_LINK']) {
                    <a class="grid-atag" (click)="productDesignationDownloadData(dataItem.PRODUCT_DESIGNATION_LINK)">
                      <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                    </a>
                  }
                  @if (!dataItem['PRODUCT_DESIGNATION_LINK']) {
                    <span [innerHTML]="dataItem[column.FIELD]"></span>
                  }
                </div>
              }

              @if (dataItem[column.FIELD] != null && column.FIELD == 'MAX_PRESSURE'  && column?.IsClickField == true) {
                <div>
                  @if (dataItem['MAX_PRESSURE_LINK']) {
                    <a class="grid-atag" (click)="sendClickedData(dataItem.MODEL_SEQ, dataItem['VIEW_MODEL_LISTING_DETAILS'], column?.FIELD, dataItem[column?.FIELD],dataItem)">
                      <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                    </a>
                  }
                  @if (!dataItem['MAX_PRESSURE_LINK']) {
                    <span [innerHTML]="dataItem[column.FIELD]"></span>
                  }
                </div>
              }

              @if (dataItem[column.FIELD] != null && column.FIELD == 'MAX_TEMP'  && column?.IsClickField == true) {
                <div>
                  @if (dataItem['MAX_TEMP_LINK']) {
                    <a class="grid-atag" (click)="sendClickedData(dataItem.MODEL_SEQ, dataItem['VIEW_MODEL_LISTING_DETAILS'], column?.FIELD, dataItem[column?.FIELD],dataItem)">
                      <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
                    </a>
                  }
                  @if (!dataItem['MAX_TEMP_LINK']) {
                    <span [innerHTML]="dataItem[column.FIELD]"></span>
                  }
                </div>
              }

              @if (column?.FIELD === 'RELATED_FOOTNOTES') {
                <div>
                  @if (showOnlyModelDetails(dataItem)) {
                    <p>
                      <a class="table-ancher" (click)="viewModelEvent(dataItem);">
                        @if (!dataItem.isclicked) {
                          <span>Footnotes</span>
                        } @else {
                          <span>Hide Footnotes</span>
                        }
                        <img alt="expand-icon" title="View/Hide Footnotes" filter="img" [ngClass]="dataItem.isclicked ?  'rotateimg' : ''"
                        src="assets/images/normal_path_3618_u13104.svg">
                      </a>
                    </p>
                  } @else {
                    <p>
                      -
                    </p>
                  }
                </div>
              }
              <!-- template grid cell rendering end -->

            </dd>
          </dl>
        }
      </ng-template>
    </kendo-grid-column>
    <!-- mobile view table grid content template end -->

    <!-- web browser table grid content template start -->
    <!-- <ng-container *ngFor="let column of GridColumns"> -->

      <!-- kendo grid column main content starts from here -->
      <!-- <kendo-grid-column [field]="column.FIELD" [columnMenu]="column.ShowMenu == false? false: true"
      [filterable]="true" [title]="column.TITLE"
      [sortable]="column.SORTABLE == false? false: true" [class]="{'codeColumn': (column.FIELD == 'MODEL' && GridColumns.length> 5) ,
      'footnoteColumn': column.FIELD == 'RELATED_FOOTNOTES'}"> -->

        <!-- sort the data based on table header as column -->
        <!-- <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
          {{ column.title }}
          <span [ngClass]="column?.title != 'View Listing Details' ? 'k-icon k-i-arrows-swap' : '' "></span>
        </ng-template> -->

        <!-- set the data of table as row -->
        <!-- <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <p
           *ngIf="(dataItem[column.FIELD] != '' && dataItem[column.FIELD] != null) && column?.FIELD != 'MODEL' && column?.FIELD != 'TRADE_NAME' && column?.FIELD != 'END_USES' && column?.FIELD != 'MAX_PRESSURE' && column?.FIELD != 'MAX_TEMP' && column?.FIELD != 'CERTIFICATE_NUMBER' && column?.FIELD != 'PERFORMANCE_STANDARD_SEARCH' && column?.FIELD != 'VIEW_MODEL_LISTING_DETAILS' && column?.FIELD != 'VIEW_PRODUCT_LISTING_DETAILS' && column?.FIELD != 'VIEW_LISTING_DETAILS' && column?.FIELD != 'RELATED_FOOTNOTES'  && column?.FIELD != 'TRADE_DESIGNATION'; else dashValue">
            <span *ngIf="isSearchHighlight; else noHighlight" [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
            <ng-template #noHighlight>
              {{dataItem[column.FIELD]}}
            </ng-template>
          </p>

          <ng-template #dashValue>
            <p *ngIf="(dataItem[column.FIELD] == null || dataItem[column.FIELD] == '') && (column?.FIELD != 'VIEW_MODEL_LISTING_DETAILS' && column?.FIELD != 'VIEW_PRODUCT_LISTING_DETAILS' && column?.FIELD != 'VIEW_LISTING_DETAILS' && column?.FIELD != 'RELATED_FOOTNOTES')">
              -
            </p>
          </ng-template>

          <p *ngIf="column?.FIELD == 'TRADE_DESIGNATION'">
            <img *ngIf="dataItem.LOGO_URL != null" class="imgDimensions" [src]="dataItem.LOGO_URL" />
            <span *ngIf="dataItem.LOGO_URL == null" class="wrap_line">
              <span *ngIf="isSearchHighlight; else noHighlight"
                [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
              <ng-template #noHighlight>
                {{dataItem[column.FIELD]}}
              </ng-template>
            </span>
          </p>

          <p class="download"
            *ngIf="(column?.FIELD == 'VIEW_PRODUCT_LISTING_DETAILS' || column?.FIELD == 'VIEW_MODEL_LISTING_DETAILS' || column?.FIELD == 'VIEW_LISTING_DETAILS')">
            <img [src]="'assets/images/Asset3mdpi.png'" [alt]="column.FIELD" class="listingDetails"
            (click)="sendClickedData(dataItem.SEQ, dataItem[column?.FIELD], column?.FIELD,'',dataItem)"
              style="cursor:pointer; margin-left: 30%;" id="{{column.FIELD}}Icon">
          </p>

          <div *ngIf="dataItem[column.FIELD] != null && column?.FIELD === 'MODEL' && column?.IsClickField !=true">

            <p *ngIf="isViewModel(dataItem[column.FIELD])">
              <a (click)="addViewModelData(dataItem.PRO_SEQ, dataItem.isclicked = !dataItem.isclicked, dataItem.MODEL);"
                class="table-ancher">
                <span [ngClass]="dataItem.isclicked ? 'modelLabelClicked' : ''">View Models</span>
                <img [ngClass]="dataItem.isclicked ?  'imgclicked' : ''"
                  [src]="dataItem.isclicked? 'assets/images/normal_path_3618_u13104.svg' : 'assets/images/normal_path_3618_u13104.svg'"
                  alt="expand-icon" title="View Models" filter="img">
              </a>
              <span [ngClass]="dataItem.isclicked ? 'modelLabelCount' : 'modelLabelCount_normal'" class="block"
                [ngBind]="calcViewModelCount(dataItem, dataItem[column.FIELD])">
                {{dataItem.viewModelCount}} <span
                  [ngClass]="dataItem.isclicked ? 'modelLabeltext' : 'modelLabeltext_normal'"> Models exists</span>
              </span>
            </p>

            <p *ngIf="!isViewModel(dataItem[column.FIELD])">
              <span *ngIf="isSearchHighlight; else noHighlight"
                [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
              <ng-template #noHighlight>
                {{dataItem[column.FIELD]}}
              </ng-template>
            </p>
          </div>

          <div
            *ngIf="dataItem[column.FIELD] != null && (column?.FIELD === 'MODEL' || column?.FIELD === 'END_USES' || column?.FIELD === 'TRADE_NAME') && column?.IsClickField == true">
            <a class="grid-atag" (click)="sendClickedData(dataItem.MODEL_SEQ, dataItem['VIEW_MODEL_LISTING_DETAILS'], column?.FIELD, dataItem[column?.FIELD],dataItem)">
              <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
            </a>
          </div>

          <div *ngIf="dataItem[column.FIELD] != null && column?.FIELD === 'TRADE_NAME' && column?.IsClickField != true">
            <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
          </div>

          <div  *ngIf="dataItem[column.FIELD] != null && column.FIELD == 'PERFORMANCE_STANDARD_SEARCH'  && column?.IsClickField == true">

            <a class="grid-atag" *ngIf="dataItem['PERFORMANCE_STANDARD_LINK']">           
              <span *ngIf="dataItem[column.FIELD] != null">
                <span *ngFor="let prop of dataItem['PERFORMANCE_STANDARD_LINK'] let i=index">              
                  <span *ngIf="prop.link == null" class="over-grid-tag" [innerHTML]="prop.name | highlight: searchText" ></span>              
                  <span *ngIf="i!=dataItem['PERFORMANCE_STANDARD_LINK'].length-1">&#44;&nbsp;</span>
                  <span *ngIf="prop.link != null" [innerHTML]="prop.name | highlight: searchText" (click)="sendDownloadData(prop.link)"></span>                
                </span>
              </span>
            </a>
           <span *ngIf="!dataItem['PERFORMANCE_STANDARD_LINK']" [innerHTML]="dataItem[column.FIELD]"></span>
          </div>

          <div  *ngIf="dataItem[column.FIELD] != null && column.FIELD == 'CERTIFICATE_NUMBER'  && column?.IsClickField == true">
            <a class="grid-atag" *ngIf="dataItem['CERTIFICATE_NUMBER_LINK']" (click)="certDownloadData(dataItem.CERTIFICATE_NUMBER_LINK)">
              <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
            </a>
            <span *ngIf="!dataItem['CERTIFICATE_NUMBER_LINK']" [innerHTML]="dataItem[column.FIELD]"></span>
          </div>

          <div *ngIf="dataItem[column.FIELD] != null && column.FIELD == 'MAX_PRESSURE'  && column?.IsClickField == true">
            <a class="grid-atag" *ngIf="dataItem['MAX_PRESSURE_LINK']" (click)="sendClickedData(dataItem.MODEL_SEQ, dataItem['VIEW_MODEL_LISTING_DETAILS'], column?.FIELD, dataItem[column?.FIELD],dataItem)">
              <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
            </a>
            <span *ngIf="!dataItem['MAX_PRESSURE_LINK']" [innerHTML]="dataItem[column.FIELD]"></span>
          </div>

          <div  *ngIf="dataItem[column.FIELD] != null && column.FIELD == 'MAX_TEMP'  && column?.IsClickField == true">
            <a class="grid-atag" *ngIf="dataItem['MAX_TEMP_LINK']" (click)="sendClickedData(dataItem.MODEL_SEQ, dataItem['VIEW_MODEL_LISTING_DETAILS'], column?.FIELD, dataItem[column?.FIELD],dataItem)">
              <span [innerHTML]="dataItem[column.FIELD] | highlight: searchText"></span>
            </a>
            <span *ngIf="!dataItem['MAX_TEMP_LINK']" [innerHTML]="dataItem[column.FIELD]"></span>
          </div>

          <div *ngIf="column?.FIELD === 'RELATED_FOOTNOTES'">

            <p *ngIf="showOnlyModelDetails(dataItem); else nocontent">
              <a class="table-ancher" (click)="viewModelEvent(dataItem);">
                <span [ngClass]="dataItem.isclicked ? 'modelLabelClicked' : ''">View Footnotes</span>
                <img [ngClass]="dataItem.isclicked ?  'imgclicked' : ''"
                  [src]="dataItem.isclicked? 'assets/images/normal_path_3618_u13104.svg' : 'assets/images/normal_path_3618_u13104.svg'"
                  alt="expand-icon" title="View Footnotes" filter="img">
              </a>
            </p>

            <ng-template #nocontent>
              <p>
                -
              </p>
            </ng-template>

          </div>
        </ng-template> -->

      <!-- </kendo-grid-column> -->
    <!-- </ng-container> -->
    <!-- web browser table grid content template end -->

    <!-- foot note table -->
    <ng-template kendoGridDetailTemplate let-dataItem [kendoGridDetailTemplateShowIf]="showOnlyModelDetails">
      <section class="footnote_sec">
        <div>
          <pre>{{dataItem.RELATED_FOOTNOTES}}</pre>
        </div>        
      </section>
    </ng-template>

    <!-- table pagination started -->
    <ng-template kendoPagerTemplate>
      @if (totalRecords > pageSize && (tabelID != 'productDetails' && tabelID != 'modelDetails' && tabelID != 'categoryDetails')) {
        <div class="pagerClass">
          <div class="d-flex align-items-center">
            <span style="padding-right: 10px;">Show</span>
            <kendo-pager-page-sizes [pageSizes]="pageSizes" (pageSizeChange)="onPageSizeChange($event)">
            </kendo-pager-page-sizes>
            <kendo-grid-messages pagerItemsPerPage="Items"></kendo-grid-messages>
          </div>
          <kendo-grid-spacer></kendo-grid-spacer>
          <kendo-pager-info></kendo-pager-info>
          <kendo-pager-prev-buttons class="borderClass"></kendo-pager-prev-buttons>
          <kendo-pager-numeric-buttons class="borderClass" [buttonCount]="3"></kendo-pager-numeric-buttons>
          <kendo-pager-next-buttons class="borderClass"></kendo-pager-next-buttons>
        </div>
      }

      @if (totalRecords < pageSize && (tabelID != 'productDetails' && tabelID != 'modelDetails' && tabelID != 'categoryDetails')) {
        <div class="pagerClass">
          <kendo-grid-spacer></kendo-grid-spacer>
          <kendo-pager-info></kendo-pager-info>
        </div>
      }
    </ng-template>

    <kendo-grid-pdf fileName="searchResults.pdf" [allPages]="true" paperSize="A4" [repeatHeaders]="true"
      [landscape]="true">
    </kendo-grid-pdf>
  </kendo-grid>
</div>
